export const FOODSTEPS_SUPPORT_EMAIL = "support@foodsteps.earth";
